<template>
  <div class="params-person-info-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" size="mini" type="primary"
                     icon="el-icon-plus">新增
          </el-button>
          <el-button @click="importPerson" size="mini" type="primary"
                     icon="el-icon-upload2">OA导入
          </el-button>
          <el-button @click="clickEdit" size="mini" type="primary"
                     icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="del" size="mini" type="primary"
                     icon="el-icon-delete">删除
          </el-button>
          <el-button @click="showSetRole" size="mini" type="primary"
                     icon="el-icon-s-management">切换角色
          </el-button>
          <el-button @click="getData" size="mini" type="primary"
                     icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary"
                     icon="el-icon-refresh">重置
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15">
        <div class="item">
          <div class="span">工号</div>
          <el-input v-model="obj.txt11" placeholder="请输入工号" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">姓名</div>
          <el-input v-model="obj.txt11" placeholder="请输入姓名" size="mini"></el-input>
        </div>
        <div class="item">
          <span class="span">部门</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'},{value:'选项5',label:'选项5'},{value:'全部',label:'全部'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">岗位</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'},{value:'选项5',label:'选项5'},{value:'全部',label:'全部'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">工种</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'},{value:'选项5',label:'选项5'},{value:'全部',label:'全部'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="person-info-box mt-15">
      <div class="left mr-15">
        <div class="table">
          <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                    @current-change="handleCurrentChange" style="width:100%">
            <el-table-column label="工号" property="id"></el-table-column>
            <el-table-column label="姓名"></el-table-column>
            <el-table-column label="部门"></el-table-column>
            <el-table-column label="性别"></el-table-column>
            <el-table-column label="办公地点"></el-table-column>
            <el-table-column label="班组"></el-table-column>
            <el-table-column label="工种"></el-table-column>
            <el-table-column label="岗位"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <span class="zsf-icon zsf-icon-touxiang mr-3"></span>
          <span>个人信息详情</span>
        </div>
        <div class="img">
          <img class="mt-10 mb-10" src="../../common/images/person.jpg" style="height:150px"/>
          <!--<span style="font-size:180px;" class="zsf-icon zsf-icon-photo"></span>-->
        </div>
        <div class="font18 t-center">张三丰</div>
        <div class="info">
          <div class="item">
            <div class="span">工号</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">部门</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">工种</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">工作区域</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">班级名称</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">职位</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">联系电话</div>
            <el-input value="12345" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">状态</div>
            <el-input value="在职" size="mini"></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination pt-15 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="700px" :visible.sync="addDialogShow">
      <div class="person-add-dialog-box">
        <div class="image">
          <img class="default" src="../../common/images/person.jpg"/>
          <!--<input type="file" @change="uploadTitleImage"/>-->
        </div>
        <div class="add-box">
          <div class="o-hidden">
            <span class="span">姓名</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
          <div class="o-hidden">
            <span class="span">性别</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择性别">
              <el-option
                  v-for="item in [{value:'男',label:'男'},{value:'女',label:'女'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="o-hidden">
            <span class="span">工号</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
          <div class="o-hidden">
            <span class="span">部门</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择部门">
              <el-option
                  v-for="item in [{value:'部门1',label:'部门1'},{value:'部门2',label:'部门2'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="o-hidden">
            <span class="span">员工状态</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择员工状态">
              <el-option
                  v-for="item in [{value:'在职',label:'在职'},{value:'离职',label:'离职'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="o-hidden">
            <span class="span">联系电话</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
          <div class="o-hidden">
            <span class="span">岗位</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择岗位">
              <el-option
                  v-for="item in [{value:'岗位1',label:'岗位1'},{value:'岗位2',label:'岗位2'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="o-hidden">
            <span class="span">班组</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
          <div class="o-hidden">
            <span class="span">工种</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择工种">
              <el-option
                  v-for="item in [{value:'工种1',label:'工种1'},{value:'工种2',label:'工种2'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="o-hidden">
            <span class="span">办公地点</span>
            <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择办公地点">
              <el-option
                  v-for="item in [{value:'办公地点1',label:'办公地点1'},{value:'办公地点2',label:'办公地点2'}]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="切换角色" width="700px" :visible.sync="toggleRoleIsShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">角色</span>
          <el-select style="width:100%" size="mini" v-model="role" placeholder="请选择角色">
            <el-option
                v-for="item in [{value:'超级管理员',label:'超级管理员'},{value:'管理员',label:'管理员'},{value:'普通用户',label:'普通用户'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toggleRoleIsShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitRole">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false,
        toggleRoleIsShow: false,
        role: '超级管理员'
      };
    },

    computed: {},

    created() {
      this.getData();
    },

    methods: {
      showSetRole(){
        this.toggleRoleIsShow = true;
      },
      submitRole(){
        this.toggleRoleIsShow = false;
      },
      toggleAdmin(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.$confirm("确定要取消员工“张三丰”的管理员吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      },
      uploadTitleImage(){
      },
      importPerson(){
        alert('调用导入接口');
      },
      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        setTimeout(() => {
          this.tableLoading = false;
          this.pagination.total = 222;
          this.list = [
            {id: 1},
            {id: 2},
            {id: 3},
            {id: 4},
            {id: 5},
            {id: 6},
            {id: 7},
            {id: 8},
            {id: 9},
            {id: 10}
          ];
        }, 10);
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import url("../../common/less/variable.less");

  .params-person-info-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .person-add-dialog-box {
      width: 100%;
      display: flex;
      .image {
        width: 250px;
        position: relative;
        .default {
          width: 200px;
        }
        input {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .add-box {
        width: 0;
        flex: 1;
      }
    }
    .person-info-box {
      width: 100%;
      display: flex;
      align-items: stretch;
      .left {
        flex: 1;
        width: 0;
      }
      .right {
        width: 250px;
        padding: 10px;
        background: @colorHeader;
        color: white;
        .title {
          width: 100%;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        .img {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .info {
          margin-top: 15px;
          .item {
            float: left;
            display: flex;
            margin-bottom: 6px;
            align-items: center;
            justify-content: flex-start;
            .span {
              margin-right: 5px;
              width: 60px;
            }
            .el-select,
            .el-input {
              width: 160px;
              border: none;
            }
            .el-input__inner {
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
</style>
